import React, { useEffect, useState } from "react";
import Card from "components/Card/Card";

import { Text, Flex, SimpleGrid, Button, useColorMode } from "@chakra-ui/react";
import card from "components/Card/Card";
import axios from "axios";
import apiUrl from "variables/api";
import { toast } from "react-toastify";

function Page() {
  const { colorMode } = useColorMode();
  const [table, setTable] = useState([]);

  useEffect(() => {
    axios
      .get(apiUrl + "/data/s4-officers-view", {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        console.log(response.data);
        if (response.data.length !== 0) {
          setTable(response.data);
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("Napotkano błąd podczas pobierania danych z API");
      });
  }, []);

  return (
    <Flex flexDirection="column" pt={{ base: "120px", md: "75px" }}>
      <SimpleGrid columns={{ sm: 1, md: 2, xl: 4 }} spacing="24px" mb="20px">
        {!table.length && (
            <Card>
                <Text color="gray.300" fontSize="2xl" fontWeight="bold">
                Brak aktywnych S4
                </Text>
            </Card>
        )}
        {table?.map((card) => (
          <Card minH="125px">
            <Text
              color={
                card.status == 1
                  ? "orange.600"
                  : card.active
                  ? "green.600"
                  : "red.800"
              }
              fontWeight="bold"
            >
              <Text as="span" color="white">
                #{card.id}{" "}
              </Text>
              {card.status == 1
                ? "ANULOWANE"
                : card.active
                ? "AKTYWNE"
                : "NIE AKTYWNE"}
            </Text>
            <Text color="gray.300" fontSize={""} fontWeight="bold">
              <Text as="span" color="white">
                Osoba:{" "}
              </Text>
              {card.personDisplayName}
            </Text>
            <Text color="gray.300" fontSize={""} fontWeight="bold">
              <Text as="span" color="white">
                Szkółka:{" "}
              </Text>
              {card.sp ? "TAK" : "NIE"}
            </Text>
            <Text color="gray.300" fontSize={""} fontWeight="bold">
              <Text as="span" color="white">
                Od:{" "}
              </Text>
              {card.start.replace("T", " ").slice(0, -8)}
            </Text>
            <Text color="gray.300" fontSize={""} fontWeight="bold">
              <Text as="span" color="white">
                Do:{" "}
              </Text>
              {card.end.replace("T", " ").slice(0, -8)}
            </Text>
            <Text color="gray.300" fontSize={""} fontWeight="bold">
              <Text as="span" color="white">
                Powód:{" "}
              </Text>
              {card.reason}
            </Text>
            <Text color="gray.300" fontSize={""} fontWeight="bold">
              <Text as="span" color="white">
                Nałożone przez:{" "}
              </Text>
              {card.senderDisplayName}
            </Text>
          </Card>
        ))}
      </SimpleGrid>
    </Flex>
  );
}

export default Page;
